import React from 'react';

import {
  ErrorMessage,
  IsLoading,
  RegisterFormFieldType
} from '../../../../../types';
import { SubmitSourceFilesToTaskFormData } from './SubmitSourceFilesToTaskForm.types';

import { Form } from '../../../../../helpers/Form';
import {
  DropzoneField,
  DropzoneFieldRequiredProps
} from '../../../../../helpers/FormFields/DropzoneField';
import { CheckBoxField } from '../../../../../helpers/FormFields/CheckBoxField';
import {
  DropzoneHelperFileIds,
  DropzoneHelperFiles
} from '../../../../../helpers/dropzone/DropzoneHelper';

import { TaskFields } from '../../../tasksTypes';
import { stringsKeys } from '../../../../../locales/keys';

interface SubmitSourceFilesToTaskFormProps {
  form: string;
  isLoading?: IsLoading;
  registerAutoSubmit?: RegisterFormFieldType<HTMLInputElement>;
  sourceFileIdsValidationError: ErrorMessage;
  initialFiles?: DropzoneHelperFiles;
  initialFileIds?: DropzoneHelperFileIds;
  onChangeFiles?: (files: DropzoneHelperFiles) => void;
}

function SubmitSourceFilesToTaskForm({
  form,
  control,
  isLoading,
  registerAutoSubmit,
  sourceFileIdsValidationError,
  initialFiles,
  initialFileIds,
  onChangeFiles
}: SubmitSourceFilesToTaskFormProps &
  DropzoneFieldRequiredProps<SubmitSourceFilesToTaskFormData>) {
  return (
    <Form className="flex-1 overflow-y-auto px-2" id={form}>
      <div className="p-4">
        <DropzoneField
          withoutTabs
          control={control}
          name={TaskFields.SOURCE_FILE_IDS}
          error={sourceFileIdsValidationError}
          type="sourceFiles"
          labelFor="submit-task-source-files"
          disabled={isLoading}
          initialFiles={initialFiles}
          initialFileIds={initialFileIds}
          onChangeFiles={onChangeFiles}
          syncUpdateAction
        />

        {registerAutoSubmit && (
          <div className="mt-4">
            <CheckBoxField
              id="submit_source_files_when_uploaded_field"
              ref={registerAutoSubmit.ref}
              name={registerAutoSubmit.name}
              i18nLabel={stringsKeys.submitFilesWhenUploaded}
              disabled={isLoading}
              onChange={registerAutoSubmit.onChange}
            />
          </div>
        )}
      </div>
    </Form>
  );
}

export default SubmitSourceFilesToTaskForm;
